import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';

import * as Models from '../../models/commonModels';
import * as CostEstimationModels from '../../models/cost-estimation/cost-estimation';
import { CostEstimationSearchModel } from '../../models/cost-estimation/cost-estimationSearch';
import { EnvironmentService } from '../../../app/services/environment.service';

@Injectable({
  providedIn: 'root'
})

export class CostEstimationService {

  constructor(private httpClient: HttpClient,
    private environment: EnvironmentService
  ) { }


  public getList(Search: CostEstimationSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<CostEstimationModels.CostEstimationListModel>(`${this.environment.getApiURL()}/cost-estimation/list`, Search, options);
  }

  public set(CostEstimation: Models.Request<CostEstimationModels.CostEstimationModel>) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.Response<CostEstimationModels.CostEstimationModel>>(`${this.environment.getApiURL()}/cost-estimation/set`, CostEstimation, options);
  }

  public get(request: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.Response<CostEstimationModels.CostEstimationModel>>(`${this.environment.getApiURL()}/cost-estimation/get`, request, options);
  }

  public serviceLineRemove(request: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.Response<number>>(`${this.environment.getApiURL()}/cost-estimation/service-line-remove`, request, options);
  }

  public serviceLineAccept(request: Models.RequestStateModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.Response<CostEstimationModels.CostEstimationServiceLine>>(`${this.environment.getApiURL()}/cost-estimation/service-line-accept`, request, options);
  }

  public serviceLineDone(request: Models.RequestStateModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.Response<CostEstimationModels.CostEstimationServiceLine>>(`${this.environment.getApiURL()}/cost-estimation/service-line-done`, request, options);
  }

  public partLineRemove(request: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.Response<number>>(`${this.environment.getApiURL()}/cost-estimation/part-line-remove`, request, options);
  }

  public getStatusDictionary() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<CostEstimationModels.CostEstimationStatusDictionaryListModel>(`${this.environment.getApiURL()}/cost-estimation/status-dictionary`, options);
  }

  public setNote(CostEstimation: Models.Request<CostEstimationModels.CostEstimationNoteModel>) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.Response<CostEstimationModels.CostEstimationModel>>(`${this.environment.getApiURL()}/cost-estimation/set-note`, CostEstimation, options);
  }

  public partLineAccept(request: Models.RequestStateModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.Response<CostEstimationModels.CostEstimationPartLine>>(`${this.environment.getApiURL()}/cost-estimation/part-line-accept`, request, options);
  }

  public getCostEstimationPDF(request: Models.RequestStateModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environment.getApiURL()}/cost-estimation/pdf`, request, options);
  }

  public accept(request: Models.RequestStateModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.Response<CostEstimationModels.CostEstimationModel>>(`${this.environment.getApiURL()}/cost-estimation/accept`, request, options);
  }

  public cancel(request: Models.RequestStateModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.Response<CostEstimationModels.CostEstimationModel>>(`${this.environment.getApiURL()}/cost-estimation/cancel`, request, options);
  }

  public doIt(request: Models.RequestStateModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.Response<CostEstimationModels.CostEstimationModel>>(`${this.environment.getApiURL()}/cost-estimation/do-it`, request, options);
  }

  public acceptAll(request: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.Response<CostEstimationModels.CostEstimationModel>>(`${this.environment.getApiURL()}/cost-estimation/accept-all`, request, options);
  }

}
